import tonIcon from '@/Assets/images/wallets/ton.png';

export const useTonConnectedIcon = () => {
  return tonIcon;
};
